import React, { useState } from 'react'
import classes from "./PinsView.module.css";
import EditPinOutputList from '../PinOut/OutputV2/OutputList/EditPinOutputList';
import EditPinInputList from '../PinInput/InputPinV2/InputList/EditPinInputList';
import EditPin, { HandleResponseData } from './EditPin';
import Card from '../../Cards/Card';
import { Button } from 'primereact/button';
import { UpdateDeviceDetails, getSingleDeviceData } from '../../../../Api Methods/Api';

const EditPinsView = ({ singleDevicePins, HandleToggleEditPinView, showEditPinForm, setShowEditPinForm, HandleShowEditPinForm, setPinEdited, siteData, setSiteData, DeviceDetails, DeviceDetailsExtras, DeviceID, apiData, dispatch}) => {
    const { OutputPins, InputPins, singleDeviceSettingData } = singleDevicePins;
    console.log(OutputPins);

    const DeviceUUID = siteData.data[0].uuid;

    const [PinDetails, setPinDetails] = useState(null)
    const [selectedPins, setSelectedPins] = useState(new Set());
    const [isUpdatingVisibility, setIsUpdatingVisibility] = useState(false);


    const HandleSetPinsVisibility = async (isVisible) => {
        if (selectedPins.size === 0 || isUpdatingVisibility) return;
        setIsUpdatingVisibility(true);

        try {
            // get fresh device details before editing
            const freshDeviceData = await getSingleDeviceData(apiData, DeviceUUID, dispatch);
            const freshDeviceDetails = JSON.parse(freshDeviceData.data[0].deviceDetails);

            const updatedDeviceDetails = { ...freshDeviceDetails };
            selectedPins.forEach(pin => {
                updatedDeviceDetails[pin] = {
                    ...updatedDeviceDetails[pin],
                    active: isVisible ? 1 : 0,
                    notificationActive: isVisible ? updatedDeviceDetails[pin].notificationActive : 0
                };
            });

            const response = await UpdateDeviceDetails(apiData, {
                deviceDetails: updatedDeviceDetails
            }, DeviceID, dispatch);

            if (response) {
                const newSiteData = { ...siteData.data[0], deviceDetails: JSON.stringify(updatedDeviceDetails) };
                setSiteData(HandleResponseData(newSiteData, dispatch));
                setPinEdited(true);
                setSelectedPins(new Set());
            }
        } finally {
            setIsUpdatingVisibility(false);
        }
    };

    console.log('pin details', PinDetails);


    return (
        <>
            <h3 style={{color:"rgb(85, 173, 155)", fontSize:"22px", fontWeight:"500", textAlign: "center", padding:"10px"}}>Edit mode</h3>
            {showEditPinForm ?
                <EditPin PinDetails={PinDetails} setShowEditPinForm={setShowEditPinForm} HandleToggleEditPinView={HandleToggleEditPinView} setPinEdited={setPinEdited} setSiteData={setSiteData} DeviceDetails={DeviceDetails} DeviceDetailsExtras={DeviceDetailsExtras} SmartLocks={singleDeviceSettingData.iglooLocks}/>
                :
                <div className={classes["PinView-container"]}>
                    <div className={classes.visibilityContainer}>
                        <div className={classes.visibilityTopRow}>
                            <p className={classes.selectedText}>{selectedPins.size} selected</p>
                            <p 
                                className={selectedPins.size >= 1 ? classes.clearBtnActive : classes.clearBtn}
                                onClick={() => setSelectedPins(new Set())}
                            >
                                Clear
                            </p>
                        </div>
                        <div className={classes.btnRow}>
                            <Button type='button' label='Set visible' className={`${classes.visibleBtn} ${classes.visibilityBtn}`} disabled={selectedPins.size === 0 || isUpdatingVisibility} onClick={() => HandleSetPinsVisibility(true)} />
                            <Button type='button' label='Set hidden' severity='secondary' className={classes.visibilityBtn} disabled={selectedPins.size === 0 || isUpdatingVisibility} onClick={() => HandleSetPinsVisibility(false)} />
                        </div>
                    </div>
                    <EditPinOutputList OutputPins={OutputPins} polarity={singleDeviceSettingData.polarity} HandleShowEditPinForm={HandleShowEditPinForm} setPinDetails={setPinDetails} selectedPins={selectedPins} setSelectedPins={setSelectedPins} />

                    {/* check if device has no inputs if not then skip*/}
                    {singleDeviceSettingData.numInput != 0 && <EditPinInputList InputPins={InputPins} polarity={singleDeviceSettingData.polarity} HandleShowEditPinForm={HandleShowEditPinForm} setPinDetails={setPinDetails} selectedPins={selectedPins} setSelectedPins={setSelectedPins} />}

                </div>
            }
        </>
    )
}

export default EditPinsView